import React, { useEffect, useState } from "react";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import PersonIcon from "@mui/icons-material/Person";
import DatePicker from "react-datepicker";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const CommonDatePicker2 = ({ fromDate, setFromDate, toDate, setToDate }) => {
  return (
    <>
      <div className="d-flex ac-js gap-2">
        <div className="col-md-2">
          <label className="form-label">From Date</label>
          <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select from date"
          />
        </div>

        {/* To Date */}
        <div className="col-md-2 ">
          <label className="form-label">To Date</label>
          <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select to date"
            minDate={fromDate} // prevent selecting before fromDate
          />
        </div>
      </div>
    </>
  );
};

const SiteDashboard = () => {
  const [dashboardList, setDashboardList] = useState({});
  const getDashboard = () => {
    get(URL.USER_DASHBOARD)
      .then((res) => {
        if (res?.status == "success") {
          setDashboardList(res?.dashboard_datas);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <div className="dashRightView ">
      <CommonDatePicker2 />
      <div className="d-flex ac-js gap-3">
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Total Alert
            </h4>
            <AlarmOnIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.total_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              New Alert
            </h4>
            <AlarmOnIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.new_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Assigned Alert
            </h4>
            <AlarmOnIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
             {dashboardList?.allocated_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Closed Alert
            </h4>
            <AlarmOnIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.closed_alert_count}
          </h2>
        </div>
      </div>
      <div className="d-flex ac-js gap-3">
        <div className=" my-3 user-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Group 1
            </h4>
            <PersonIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
             {dashboardList?.group1_count}
          </h2>
        </div>
        <div className=" my-3 user-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Group 2
            </h4>
            <PersonIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.group2_count}
          </h2>
        </div>
        <div className=" my-3 user-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Group 3
            </h4>
            <PersonIcon style={{ color: "brown", fontSize: 30 }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
             {dashboardList?.group3_count}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default SiteDashboard;
